module.exports = __webpack_public_path__ + "img/favicon.7b7d8d9a.ico";